// extracted by mini-css-extract-plugin
export default {"fields":"FnRThN","gaps":"BnNZV2","time":"E2F7wI","mobile":"ITvFIe"};